<template lang="pug">
  router-link.blog-article(:to="`/blog/${v.id}`")
    .article-image-header(:style="{'background-image': `url(\"${v.feature}\")`}")
    .article-content
      h2.title.is-uppercase {{v.title}}
      p.is-hidden-mobile
        span.has-text-weight-normal.recent-synopsis {{v.synopsis}}
        span &nbsp;
        span.emphasized-text Read more.
      .details-bar.columns.is-multiline
        span.emphasized-text.column.is-half {{v.category}}
        span.time.column.is-half
          fa-icon(icon="clock")
          span(style="margin-left:5px;") {{v.revealDate}}
</template>

<script>
  export default {
    props: ['v']
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";

  .blog-article {
    display: block;
    box-shadow: -1px 1px 4px 1px rgba(80, 80, 80, 0.15);
    margin-bottom: 4rem;
    width: 100%;
    color: #363636;
    position: relative;

    .article-image-header {
      min-height: 200px;
      width: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .article-content {
      padding: 3rem;
      padding-bottom: 5rem;

      .details-bar {
        left: 0;
        right: 0;
        bottom: 1.5rem;
        position: absolute;
        padding: 0 3rem;

        .time {
          font-size: 14px;
          font-weight: normal;
          text-align: right;
        }
      }
    }
  }
</style>
